import React from 'react';
import DetailsPage from './DetailsPage';
import styles from './styles/DetailsPage.css';

export const DetailsPageContainer = () => {
  return (
    <div className={styles.detailsPage}>
      <DetailsPage /> 
    </div>
  );
};
